/* ═══════════════════════════════════════════════════════════════
   SORISSE — email capture and onsite tracking
   Exit intent on desktop, 55% scroll on mobile (no exit intent
   exists on touch). Never on cart or checkout, never twice.

   Subscribes straight to Klaviyo, so the welcome flow fires at
   once and nothing depends on the Shopify sync. The plain form
   post is only the fallback for a browser with no script.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var COMPANY = 'RVZgCi';   // Klaviyo public site id, meant to sit in the page
  var LIST    = 'XU4dvn';   // "Sorisse", single opt in
  var KEY     = 'sorisse.cap';

  /* ── Klaviyo onsite, for on site activity and the browse flows ── */
  if (!window.klaviyo) {
    var ks = document.createElement('script');
    ks.async = true;
    ks.src = 'https://static.klaviyo.com/onsite/js/' + COMPANY + '/klaviyo.js';
    document.head.appendChild(ks);
  }

  /* ── Viewed Product, so browse abandonment has something to fire on ──
     Reads the JSON-LD the theme already prints, rather than duplicating
     product data into a second place that can drift out of date. ── */
  if (/\/products\//.test(location.pathname)) {
    try {
      var ld = null;
      Array.prototype.forEach.call(
        document.querySelectorAll('script[type="application/ld+json"]'),
        function (node) {
          if (ld) return;
          var data = JSON.parse(node.textContent);
          var graph = data['@graph'] || [data];
          for (var i = 0; i < graph.length; i++) {
            if (graph[i]['@type'] === 'Product') { ld = graph[i]; return; }
          }
        }
      );
      if (ld) {
        var offer = ld.offers || {};
        var handle = String(ld['@id'] || '').split('/').pop().replace('#product', '');
        var item = {
          ProductName: ld.name,
          ProductID: handle,
          SKU: ld.sku,
          ImageURL: (ld.image || [])[0],
          URL: offer.url || location.href,
          Brand: 'Sorisse',
          Price: Number(offer.price),
          Categories: ['LED masks']
        };
        // klaviyo.js is async, so queue onto the array it drains on load.
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(['track', 'Viewed Product', item]);
        window.klaviyo.push(['trackViewedItem', {
          Title: item.ProductName,
          ItemId: item.ProductID,
          Categories: item.Categories,
          ImageUrl: item.ImageURL,
          Url: item.URL,
          Metadata: { Brand: item.Brand, Price: item.Price }
        }]);
      }
    } catch (e) {}
  }

  /* ── the subscribe call, shared by every form on the site ──── */
  function subscribe(email, source) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'Website',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: LIST } } }
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + r.status);
      return true;
    });
  }

  var state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) {}

  function remember(o) {
    for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) state[k] = o[k]; }
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  /* ── wire every signup form, popup or otherwise ────────────── */
  var forms = document.querySelectorAll('#capForm, [data-klaviyo]');
  Array.prototype.forEach.call(forms, function (form) {
    var field  = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!field) return;

    // A trap for anything that fills every field it finds. Built here rather
    // than in the markup so the whole capture lives in one file.
    var honey = document.createElement('input');
    honey.type = 'text';
    honey.name = 'contact[company]';
    honey.tabIndex = -1;
    honey.autocomplete = 'off';
    var hpWrap = document.createElement('div');
    hpWrap.setAttribute('aria-hidden', 'true');
    hpWrap.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden';
    hpWrap.appendChild(honey);
    form.appendChild(hpWrap);

    // Somewhere to say so if the call fails.
    var err = document.createElement('p');
    err.setAttribute('role', 'alert');
    err.hidden = true;
    err.style.cssText = 'margin:10px 0 0;font-size:13px;line-height:1.5;color:#B4402F';
    form.parentNode.insertBefore(err, form.nextSibling);

    var busy = false;

    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); return; }
      if (!field.value || field.validity.typeMismatch) return;   // let the browser say so
      if (honey.value) { e.preventDefault(); return; }           // a bot filled it in

      e.preventDefault();
      busy = true;
      var label = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'One moment'; }
      err.hidden = true;

      subscribe(field.value.trim(), form.id === 'capForm' ? 'Site popup' : 'Website')
        .then(function () {
          remember({ subscribed: true });
          if (form.id === 'capForm') { done(); }
          else { form.innerHTML = '<p class="cap__done">Thank you. It is on its way.</p>'; }
        })
        .catch(function () {
          // Never strand somebody who typed their address: fall back to the
          // ordinary form post, which Shopify handles without any script.
          busy = false;
          if (button) { button.disabled = false; button.textContent = label; }
          err.textContent = 'That did not go through. Trying another way.';
          err.hidden = false;
          form.submit();
        });
    });
  });

  /* ══ everything below is the popup itself ══════════════════ */

  var box = document.getElementById('cap');
  if (!box) return;

  if (/\/(cart|checkout|challenge|account)/.test(location.pathname)) return;  // never mid purchase
  if (state.subscribed) return;                                               // already on the list
  if (state.until && Date.now() < state.until) return;                        // dismissed recently

  var shown = false, lastFocus = null;

  function open() {
    if (shown) return;
    shown = true;
    lastFocus = document.activeElement;
    box.hidden = false;
    box.setAttribute('aria-hidden', 'false');
    var f = document.getElementById('capEmail');
    if (f && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      setTimeout(function () { f.focus(); }, 450);
    }
    document.addEventListener('keydown', onKey);
  }

  function close(days) {
    if (!shown) return;
    shown = false;
    box.hidden = true;
    box.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    remember({ until: Date.now() + (days || 30) * 864e5 });
  }

  function onKey(e) { if (e.key === 'Escape') close(30); }

  function done() {
    var inner = box.querySelector('.cap__box');
    if (!inner) return;
    inner.innerHTML =
      '<button class="cap__x" aria-label="Close">&times;</button>' +
      '<p class="cap__eyebrow">Thank you</p>' +
      '<h2 class="cap__title">It is on its way.</h2>' +
      '<p class="cap__done">Check your inbox, and your junk folder if it is not there in a few ' +
      'minutes. We will email you the day the test report arrives, whatever the number says.</p>';
    inner.querySelector('.cap__x').addEventListener('click', function () { close(3650); });
    open();
  }

  var x = document.getElementById('capX');
  var scrim = document.getElementById('capScrim');
  if (x) x.addEventListener('click', function () { close(30); });
  if (scrim) scrim.addEventListener('click', function () { close(30); });

  /* ── triggers ──────────────────────────────────────────────── */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    // desktop: leaving through the top of the window
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 4) open();
    });
    setTimeout(open, 75000);            // and a long dwell, for people who never leave the tab
  } else {
    // mobile: past the halfway mark means genuine interest
    var onScroll = function () {
      var h = document.documentElement;
      if ((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.55) {
        open();
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(open, 60000);
  }

  // The no-script fallback bounces back through Shopify with this.
  if (/customer_posted=true/.test(location.search)) { remember({ subscribed: true }); done(); }
})();
